import { z } from 'zod';

import type { FieldConfig } from '@/types/forms';

export const schema = z.object({
  fullName: z.string().trim().min(2, 'Full name must be at least 2 characters'),
  phone: z
    .string()
    .trim()
    .min(7, 'Phone must be at least 7 characters')
    .regex(/^\+?[\d\s\-().]{7,20}$/, 'Please enter a valid phone number'),
  email: z.string().trim().email('Please enter a valid email address'),
  patientType: z.enum(['new-patient', 'existing-patient'], {
    message: 'Please select your patient type',
  }),
  message: z
    .string()
    .trim()
    .min(1, 'Message is required')
    .max(500, 'Message must be 500 characters or fewer'),
});

export type ContactFormValues = z.infer<typeof schema>;

export const defaultValues: ContactFormValues = {
  fullName: '',
  phone: '',
  email: '',
  patientType: undefined as unknown as 'new-patient' | 'existing-patient',
  message: '',
};

export const fields: FieldConfig[] = [
  {
    name: 'fullName',
    type: 'text',
    label: 'Full Name',
    placeholder: 'Enter your full name',
    required: true,
    colSpan: 1,
  },
  {
    name: 'phone',
    type: 'tel',
    label: 'Phone',
    placeholder: 'Enter your phone number',
    required: true,
    colSpan: 1,
  },
  {
    name: 'email',
    type: 'email',
    label: 'Email',
    placeholder: 'Enter your email address',
    required: true,
    colSpan: 2,
  },
  {
    name: 'patientType',
    type: 'radio',
    label: 'You Are',
    required: true,
    colSpan: 2,
    options: [
      { value: 'new-patient', label: 'New patient' },
      { value: 'existing-patient', label: 'Existing patient' },
    ],
  },
  {
    name: 'message',
    type: 'textarea',
    label: 'Message',
    placeholder: 'How can we help you?',
    required: true,
    colSpan: 2,
    maxLength: 500,
  },
];

export const contactFormSchema = schema;
export const contactFormFields = fields;
export const contactFormDefaultValues = defaultValues;
